import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import styles from "./buy-validation-credits.module.scss";
import axios from "axios";
import ModalLayout from "../../../layouts/modal.layout";
import { useInputValue } from "../../../hooks/useInputValue";
import { Context } from "../../../Context";
import toast from "react-hot-toast";
import cx from "classnames";
import { Link } from "@reach/router";

const BuyValidationCreditModal = forwardRef((props, ref) => {
  const api = process.env.REACT_APP_API;
  const value = useContext(Context);
  const [setCampaignMain] = useState(undefined);
  const [selectAmount, setSelectAmount] = useState(undefined);
  const [selectedCard, setSelectedCard] = useState(false);
  const [creditCards, setCreditCards] = useState([]);
  const company = useInputValue("");
  const industry = useInputValue("");
  const country = useInputValue("");
  const campaign = useInputValue("");
  const salesNav = useInputValue("");
  const captured = useInputValue(false);
  const title = useInputValue("");

  const updateList = () => {
    axios
      .get(`${api}user/all-cc`, {
        params: {
          user: value.user._id,
        },
      })
      .then(({ data }) => {
        if (data.data) {
          setCreditCards(data.data);
        }
      });
  };

  useEffect(() => {
    updateList();
  }, []);

  useImperativeHandle(ref, () => ({
    open(c = undefined) {
      setCampaignMain(c);
      title.setValue("");
      company.setValue("");
      industry.setValue("");
      country.setValue("");
      campaign.setValue("");
      salesNav.setValue("");
      captured.setValue(false);
    },
  }));

  const buy = () => {
    const api = process.env.REACT_APP_API;
    let body;
    let price = 3900;

    if (selectAmount === 50000) {
      price = 19500;
    } else if (selectAmount === 100000) {
      price = 39000;
    }

    body = {
      user: value.user._id,
      token: selectedCard,
      price: price,
      credits: selectAmount,
    };

    if (!selectedCard || !selectAmount) {
      toast.error("Select a card and amount");
      return;
    }

    const promise = axios.post(`${api}user/validation-credit-payment`, body).then(({ data }) => {
      if (data.error) {
        console(data.error);
      } else {
        if (data === "Payment Failed") {
          props.updateUser();
          props.setOpen();
        } else {

          props.updateUser();
          props.setOpen();
        }
      }
    });

    toast.promise(promise, {
      loading: "Processing...",
      success: "Payment Successful!",
      error: "Uh oh, there was an error!",
    });
  };

  return (
    <ModalLayout
      title={"Buy Validation Credits"}
      open={true}
      close={props.setOpen}
      customButton={buy}
      customButtonText={"Buy"}
    >
      <>
        <div className={styles.buyValidationCreditModal}>
          <div
            className={cx(styles.option, selectAmount === 10000 && styles.active)}
            onClick={() => setSelectAmount(10000)}
          >
            <h4>10,000 Credits</h4>
            <h3>$39</h3>
          </div>
          <div
            className={cx(styles.option, selectAmount === 50000 && styles.active)}
            onClick={() => setSelectAmount(50000)}
          >
            <h4>50,000 Credits</h4>
            <h3>$195</h3>
          </div>
          <div
            className={cx(
              styles.option,
              selectAmount === 100000 && styles.active
            )}
            onClick={() => setSelectAmount(100000)}
          >
            <h4>100,000 Credits</h4>
            <h3>$390</h3>
          </div>
        </div>
        <div className={styles.myCards}>
          <label htmlFor="">
            My Cards
            <Link to="/profile/billing">Add Card</Link>
          </label>
          <div className={styles.myCreditCards}>
            {creditCards.map((cc) => {
              return (
                <div
                  className={cx(
                    styles.creditCardsGrid,
                    selectedCard === cc.id && styles.active
                  )}
                  key={cc.id}
                  onClick={() => setSelectedCard(cc.id)}
                >
                  <div className="brand">
                    {cc.brand === "Visa" && <i className="fab fa-cc-visa"></i>}
                    {cc.brand === "MasterCard" && (
                      <i className="fab fa-cc-mastercard"></i>
                    )}
                    {cc.brand === "American Express" && (
                      <i className="fab fa-cc-amex"></i>
                    )}
                  </div>
                  <div className="data">
                    <div className={styles.number}>
                      {cc.brand} **** {cc.last4}
                    </div>
                    <div className={styles.expires}>
                      Expires {cc.exp_year}/{cc.exp_month}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    </ModalLayout>
  );
});

export default BuyValidationCreditModal;
